import React, { useEffect } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import {
  createBrowserRouter,
  RouterProvider,
  useNavigate,
  useLocation,
  Outlet,
  useRouteError,
} from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import { isTokenExpired } from "../services/config/authToken";

// Auth pages
// import Dashboard from "../../pages/Dashboard";
import Events from "../../pages/Events";
import AboutEvent from "../../pages/AboutEvent";
import Users from "../../pages/Users";
import Historic from "../../pages/Historic";
import Contracts from "../../pages/Contracts";
import AppsMobile from "../../pages/Apps";
// Feature flag do redesign do editor de templates (V2).
// true  = usa o editor novo (painéis React modernos).
// false = usa o editor legado (visual antigo do GrapesJS).
// Para reverter completamente: colocar em false e/ou remover a linha do V2.
const USE_TEMPLATE_EDITOR_V2 = true;
import HtmlEditorLegacy from "../../pages/HtmlEditor";
import HtmlEditorV2 from "../../pages/HtmlEditorV2";
const HtmlEditor = USE_TEMPLATE_EDITOR_V2 ? HtmlEditorV2 : HtmlEditorLegacy;
import Templates from "../../pages/Templates";
import Drive from "../../pages/Drive";
import Dictionary from "../../pages/Dictionary";
import InteegraCreator from "../../pages/InteegraCreator";
import EventType from "../../pages/EventType";
import StatusRsvp from "../../pages/StatusRsvp";
import Profiles from "../../pages/Profiles";

// Default Pages
import Login from "../../pages/LoginPage";
import LoginTeste from "../../pages/Teste";
import SSO from "../../components/SSO";
import PublicTemplate from "../../pages/PublicTemplate";

// About Event Screens
import Participants from "../../pages/AboutEvent/Participant/Participants";
import Schedule from "../../pages/AboutEvent/Schedule/Schedule";
import Feed from "../../pages/AboutEvent/Feed/Feed";
import Notification from "../../pages/AboutEvent/Notification/Notification";
import Menu from "../../pages/AboutEvent/Menu/Menu";
import SuperTela from "../../pages/AboutEvent/SuperTela/SuperTela";
import Group from "../../pages/AboutEvent/group/group";
import Voo from "../../pages/AboutEvent/Voo/Voo";
import DashboardLogistics from "../../pages/AboutEvent/DashboardLogistics";
import Transfer from "../../pages/AboutEvent/Transfer/Transfer";
import Hotel from "../../pages/AboutEvent/Hotel/Hotel";
import Ranking from "../../pages/AboutEvent/ranking";
import ConfigRanking from "../../pages/AboutEvent/ranking/configRanking";
import Rsvp from "../../pages/AboutEvent/rsvp/index";
import Email from "../../pages/AboutEvent/templates/email";
import Web from "../../pages/AboutEvent/templates/web";
import DownloadFiles from "../../pages/AboutEvent/DownLoadFiles";
import ReportParticipants from "../../pages/AboutEvent/DownLoadFiles/Reports/participants/ReportParticipants";
import ReportDownloads from "../../pages/AboutEvent/DownLoadFiles/Reports/downloads/ReportDownloads";
import RegistrationFunctions from "../../pages/AboutEvent/RegistrationFunctions";
import ReportFunctions from "../../pages/AboutEvent/RegistrationFunctions/reportFunctions";
import Certificate from "../../pages/AboutEvent/Certificate";
import ReportCertificate from "../../pages/AboutEvent/Certificate/report";
import ReportSurvey from "../../pages/AboutEvent/Survey/report";
import UploadApp from "../../pages/AboutEvent/UploadApp";
import Dashboard from "../../pages/AboutEvent/Dashboard/Dashboard";
import Match from "../../pages/AboutEvent/Match";
import DashTupperware from "../../pages/AboutEvent/DashTupperware/DashTupperware";
import Promo from "../../pages/AboutEvent/Promo/promo";
import Ticket from "../../pages/AboutEvent/Ticket/ticket";
import Split from "../../pages/AboutEvent/Split/split";
import Sorteio from "../../pages/AboutEvent/Sorteio";
import ConsolidatedSales from "../../pages/AboutEvent/ticketSales/ConsolidatedSales";
import AnalyticalSales from "../../pages/AboutEvent/ticketSales/AnalyticalSales";
import Stock from "../../pages/AboutEvent/Stock";
import SchedulingReport from "../../pages/AboutEvent/schedulingReport";
import Speaker from "../../pages/AboutEvent/Speaker";
import MenuPortal from "../../pages/AboutEvent/eventsPortal";
//LeaD Collector
import LeadCollectorReports from "../../pages/AboutEvent/LeadCollector/reports";
import LeadCollectorStands from "../../pages/AboutEvent/LeadCollector/stands";
import LeadCollectorConfigurations from "../../pages/AboutEvent/LeadCollector/configurations";
//Accreditation
import AccreditationActions from "../../pages/AboutEvent/Accreditation/actions";
import AccreditationConfigurations from "../../pages/AboutEvent/Accreditation/configurations";
import AccreditationFaceRecognitionConfig from "../../pages/AboutEvent/Accreditation/faceRecognitionConfig";
import AccreditationUsers from "../../pages/AboutEvent/Accreditation/users";
import AccreditationFaceRecognitionReport from "../../pages/AboutEvent/Accreditation/faceRecognitionReport";
import AccreditationScheduleCheckinReport from "../../pages/AboutEvent/Accreditation/scheduleCheckinReport";
import AccreditationGuestsReportPage from "../../pages/AboutEvent/Accreditation/guestsReportPage";
import AccreditationGuestUniqueNumberReport from "../../pages/AboutEvent/Accreditation/guestUniqueNumberReport";
import AccreditationZebraTagMaker from "../../pages/AboutEvent/Accreditation/zebraTagMaker";
//componentes
import AuthLayout from "../../components/Layout";
import Vehicles from "../../pages/AboutEvent/vehicles/vehicles";
import QuotasPerDepartament from "../../pages/AboutEvent/PortalBoticario/QuotasPerDepartament";
import QuotasPerCP from "../../pages/AboutEvent/PortalBoticario/QuotasPerCP";
import LayoutCreateTicketing from "../../pages/AboutEvent/TicketingApp";
import PackagesPerGroup from "../../pages/AboutEvent/PortalBoticario/PackagesPerGroup";
import EventsXGroups from "../../pages/AboutEvent/PortalBoticario/EventsXGroups";
import EnabledEvents from "../../pages/AboutEvent/PortalBoticario/EnabledEvents";
import CreatePortal from "../../pages/AboutEvent/CreatePortal";
import RemoveUserVibra from "../../pages/AboutEvent/RemoveUserVibra";
import DashboardVibra from "../../pages/AboutEvent/dashboardVibra";
import GameRD from "../../pages/AboutEvent/GameRd";
import GamesXSquad from "../../pages/AboutEvent/GamesXSquad";
import GameRDPW from "../../pages/AboutEvent/GameRdPW";

function isValidDate(d) {
  return d instanceof Date && !isNaN(d);
}

const CheckAuth = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const refreshToken = useSelector(
    (state) => state.global_user_data?.data?.refreshToken,
  );

  useEffect(() => {
    if (location.pathname === "/logout") {
      localStorage.removeItem("authUser");
      localStorage.removeItem("persist:root");
      localStorage.clear();
      sessionStorage.clear();

      return navigate("/login");
    }

    if (!localStorage.getItem("authUser")) {
      window.location.reload(false);
      localStorage.setItem("authUser", "ok");
      return navigate("/login");
    }
    const isRefreshTokenExpired = isTokenExpired(refreshToken);
    if (isRefreshTokenExpired) {
      localStorage.removeItem("authUser");
      return navigate("/login");
    }
  });
  return <AuthLayout />;
};

function ErrorBoundary() {
  const navigate = useNavigate();

  /* navigate("/login");
  window.location.reload(false); */
  // Uncaught ReferenceError: path is not defined
  return <div>Error!</div>;
}

const NotFound = () => {
  return <div>Página Não encontrada!</div>;
};

const router = createBrowserRouter([
  {
    path: "/login",
    element: (
      <GoogleReCaptchaProvider
        reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
      >
        <Login />
      </GoogleReCaptchaProvider>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/sso",
    element: <SSO />,
    errorElement: <ErrorBoundary />,
  },
  {
    // Rota pública — sem wrapper do admin (sidebar/header), fora do CheckAuth.
    // Serve o template puro pra ser embedado em iframe em outras aplicações.
    path: "/template/:id",
    element: <PublicTemplate />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/",
    element: <CheckAuth />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: "*",
        element: <NotFound />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/event/templates",
        element: <HtmlEditor />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/",
        element: <Events />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/sso-test",
        element: <LoginTeste />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/events",
        element: <Events />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/dashboard",
        element: <Dashboard />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/event",
        element: <AboutEvent />,
        errorElement: <ErrorBoundary />,
        children: [
          {
            path: "/event/agenda",
            element: <Schedule />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/logistica/voo",
            element: <Voo />,
            errorElement: <ErrorBoundary />,
          },

          {
            path: "/event/logistica/transfer",
            element: <Transfer />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/logistica/hotel",
            element: <Hotel />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/participantes",
            element: <Participants />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/dashboard-tupperware",
            element: <DashTupperware />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/certificados",
            element: <Certificate />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/certificados/relatorio",
            element: <ReportCertificate />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/dashboard",
            element: <Dashboard />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/download/documentos",
            element: <DownloadFiles />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/download/relatorio/participantes",
            element: <ReportParticipants />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/download/relatorio/downloads",
            element: <ReportDownloads />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/feed",
            element: <Feed />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/functions",
            element: <RegistrationFunctions />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/functions/relatorio",
            element: <ReportFunctions />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/ranking",
            element: <Ranking />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/ranking/settings",
            element: <ConfigRanking />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/grupos",
            element: <Group />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/menu",
            element: <Menu />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/notifications",
            element: <Notification />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/match/relatorio",
            element: <Match />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/portal-eventos",
            element: <MenuPortal />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/questionario/relatorio",
            element: <ReportSurvey />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/upload/relatorio",
            element: <UploadApp />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/rsvp/formulario",
            element: <Rsvp />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/templates/email",
            element: <Email />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/templates/web",
            element: <Web />,
            errorElement: <ErrorBoundary />,
          },

          {
            path: "/event/superTela",
            element: <SuperTela />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/sorteio",
            element: <Sorteio />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/cupons",
            element: <Promo />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/tickets",
            element: <Ticket />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/splits",
            element: <Split />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/vendas-consolidadas",
            element: <ConsolidatedSales />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/vendas-analiticas",
            element: <AnalyticalSales />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/estoque",
            element: <Stock />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/relatorio-agendamento",
            element: <SchedulingReport />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/dashboard-transfer",
            element: <DashboardLogistics />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/vehicles",
            element: <Vehicles />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/customReport/dashboard-vibra",
            element: <DashboardVibra />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/customReport/exclusao-usuario-vibra",
            element: <RemoveUserVibra />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/customReport/games-x-squad",
            element: <GamesXSquad />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/portalboticario/quotas-departament",
            element: <QuotasPerDepartament />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/portalboticario/quotas-cp",
            element: <QuotasPerCP />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/portalboticario/packages",
            element: <PackagesPerGroup />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/portalboticario/events-x-groups",
            element: <EventsXGroups />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/portalboticario/enabled-events",
            element: <EnabledEvents />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/create-ticketeira",
            element: <LayoutCreateTicketing />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/leadCollector/reports",
            element: <LeadCollectorReports />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/leadCollector/stands",
            element: <LeadCollectorStands />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/leadCollector/configurations",
            element: <LeadCollectorConfigurations />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/accreditation/face-recognition-config",
            element: <AccreditationFaceRecognitionConfig />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/accreditation/users",
            element: <AccreditationUsers />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/accreditation/face-recognition-report",
            element: <AccreditationFaceRecognitionReport />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/accreditation/schedule-checkin-report",
            element: <AccreditationScheduleCheckinReport />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/accreditation/guests-report-page",
            element: <AccreditationGuestsReportPage />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/accreditation/guest-unique-number-report",
            element: <AccreditationGuestUniqueNumberReport />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/accreditation/zebra-tag-maker",
            element: <AccreditationZebraTagMaker />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/accreditation/actions",
            element: <AccreditationActions />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/accreditation/configurations",
            element: <AccreditationConfigurations />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/palestrantes",
            element: <Speaker />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/gameRD",
            element: <GameRD />,
            errorElement: <ErrorBoundary />,
          },
          {
            path: "/event/gameRDPW",
            element: <GameRDPW />,
            errorElement: <ErrorBoundary />,
          },
        ],
      },
      {
        path: "/event/criar-portal",
        element: <CreatePortal />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/type-event",
        element: <EventType />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/status-rsvp",
        element: <StatusRsvp />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/users",
        element: <Users />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/historic",
        element: <Historic />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/contracts",
        element: <Contracts />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/mobile-apps",
        element: <AppsMobile />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/inteegra-creator",
        element: <InteegraCreator />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/profiles",
        element: <Profiles />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/inteegra-drive",
        element: <Drive />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/dictionary",
        element: <Dictionary />,
        errorElement: <ErrorBoundary />,
      },
    ],
  },
]);

const UserRoutes = () => (
  <RouterProvider router={router} errorElement={<ErrorBoundary />} />
);

export default UserRoutes;
